import Component from '../abstracts/Component';

const {Crawler} = require('./../../../../node_modules/es6-crawler-detect/src')
import CarouselComponent from "./CarouselComponent";

/**
 Recommendation Engine Component
 */
export default class GoogleRecommendationEngineComponent extends Component {

  static get SELECTORS() {
    return {
      RECOMMENDATION_ENGINE_CONTAINER: '.google-recommendation-engine-container',
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER: '.google-recommendation-engine-products-container',
    };
  }

  static get CONSTANTS() {
    return {
      RECOMMENDATION_ENGINE_URL: "/ajax/recommendation-google",
      GET: "GET",
      POST: "POST",
      CHECKOUT_TEMPLATE: "t-checkout-confirm"
    };
  }

  render() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);

    if (recommendationComponent != null) {
      this.setup(recommendationComponent);
    }
  }

  constructor() {
    super();
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    let template = recommendationComponent.dataset.template;
    let checkoutTemplate = GoogleRecommendationEngineComponent.CONSTANTS.CHECKOUT_TEMPLATE;

    opts.template = template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.orderCode = recommendationComponent.dataset.orderCode;
    if (typeof(utag_data) !== 'undefined' && utag_data !== null && template === checkoutTemplate) {
      let products = utag_data.products;
      if (typeof(products) !== 'undefined' && products !== null) {
        try {
          opts.productsData = JSON.stringify(products);
        } catch(e) {
          this.warn("error trasform products to JSON");
        }
      }
      if (typeof(utag_data.order_total) !== 'undefined' && utag_data.order_total !== null) opts.totalPrice = utag_data.order_total;
    }

    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    return opts;
  }

  callServer(paramsObj, callBackOnSuccess, callBackOnFailure, timeoutTime) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();
    let template = "";
    let products = "";
    let checkoutTemplate = GoogleRecommendationEngineComponent.CONSTANTS.CHECKOUT_TEMPLATE;

    for (let key in paramsObj) {
      let value = paramsObj[key];
      if (key === "template") {
        template = value;
      }
      if (key === "productsData") {
        products = value;
      }

      params.append(key, value);
    }

    if (timeoutTime != null) {
      xhttp.timeout = timeoutTime;
    }

    if(template === checkoutTemplate) {
      xhttp.open(GoogleRecommendationEngineComponent.CONSTANTS.POST, GoogleRecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20"), true);
    } else {
      xhttp.open(GoogleRecommendationEngineComponent.CONSTANTS.GET, GoogleRecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20"), true);
    }

    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess(this);
      } else {
        if (this.readyState === 4 && (this.status === 500 || this.status === 404 || this.status === 302)) {
          callBackOnFailure();
        }
      }
    };

    xhttp.ontimeout = function () {
      console.log("Google rec. timeout reached..");
      callBackOnFailure();
    };

    xhttp.onerror = function () {
      callBackOnFailure();
    };

    if (template === checkoutTemplate) {
      xhttp.send(products);
    } else {
      xhttp.send();
    }
  }

  renderData(data) {
    let recommendationProductsComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);

    if (recommendationProductsComponent != null) {
      recommendationProductsComponent.innerHTML = data.responseText;
      recommendationComponent.classList.add('active');
      let carousel = new CarouselComponent();
      carousel.render();
    }

    let googleModel = document.getElementById("googleRecommendationModel");
    let googleTitle = document.getElementById("google-section-title");
    if (typeof(googleModel) !== 'undefined' && googleModel !== null && googleModel.value !== '' && typeof(googleTitle) !== 'undefined' && googleTitle !== null) {
      googleTitle.innerHTML = googleModel.value;
    }
    googleTitle.classList.remove("hidden");
  }

  tryAgain() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);
    this.callServer(this.getSimilarOpts(recommendationComponent), this.renderData.bind(this), this.hideComponent.bind(this), null);
  }

  hideComponent() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);

    if (recommendationComponent != null) {
      recommendationComponent.innerHTML = "";
    }
  }

  setup(recommendationComponent) {
    let timeout = recommendationComponent.dataset.timeout;
    let template = recommendationComponent.dataset.template;
    let CrawlerDetector = new Crawler();
    let userAgentString = navigator.userAgent;

    if (!CrawlerDetector.isCrawler(userAgentString)) {
      this.callServer(this.getMarketingOpts(recommendationComponent), this.renderData.bind(this), template === "t-product" ? this.tryAgain.bind(this) : this.hideComponent.bind(this), timeout);
    } else {
      this.hideComponent();
    }
  }

}
